// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { INVITE_USER } from './action-types.js';

function inviteUser(state) {
  return state.setIn(['data', 'email'], undefined);
}

export default simpleReducer(Map(), {
  [INVITE_USER]: inviteUser
});
